import { CarrierDto, KnownCarriersContainerType } from '@groundfloor-platform/mgmt-service-g-sdk';

export const SORT_ORDER_MIN = 1;
export const SORT_ORDER_MAX = 99_999;

export const SORT_ORDER_RANGE_MESSAGE = `Enter a whole number from ${SORT_ORDER_MIN} to ${SORT_ORDER_MAX}`;

/** Only a network pool's carriers are ordered against each other on the kiosk. */
export function hasEditableSortOrder(carrier: Pick<CarrierDto, 'container'>): boolean {
  return carrier.container?.containerType === KnownCarriersContainerType.NetworkPool;
}

/** Blank passes here; the field is marked required instead once a sort order is set. */
export function validateSortOrder(value: string | undefined): true | string {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) {
    return true;
  }
  const sortOrder = Number(trimmed);
  return /^\d+$/.test(trimmed) && sortOrder >= SORT_ORDER_MIN && sortOrder <= SORT_ORDER_MAX
    ? true
    : SORT_ORDER_RANGE_MESSAGE;
}

/** The sort order to send, or undefined to leave it alone: blank or unchanged sends nothing. */
export function sortOrderToSend(value: string | undefined, current?: number): number | undefined {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) {
    return undefined;
  }
  const sortOrder = Number(trimmed);
  return sortOrder === current ? undefined : sortOrder;
}
